export const HOME_INTERCEPT_LIST = ["SI_8jpfbEy2rMjKT8a"];

export const QUALTRICS_LIST: Record<string, string[]> = {
  "/": HOME_INTERCEPT_LIST,
  "/view": HOME_INTERCEPT_LIST,
  "/auth/signUp:signUpComplete": ["SI_40CHWaeY8A0UEVE"],
  "/talk": ["SI_3ObMUKeEuWUsH3g", "SI_5pUDTUP3K3F559c"],
  "/myinfo/config:withdraw:onSuccess": ["SI_7PTiP4EwuGjAzLo"],
};

export const getQualtricsList = () => {
  if (process.env.REACT_APP_USE_QUALTRICS === "true") {
    return QUALTRICS_LIST;
  } else {
    return {};
  }
};
